import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatNumber } from "@/utils"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatSalary(amount: number | null | undefined): string {
  if (!amount) return 'Thỏa thuận';
  if (amount >= 1000000000) return `${(amount / 1000000000).toFixed(1).replace(/\.0$/, '')} Tỷ`;
  if (amount >= 1000000) return `${(amount / 1000000).toFixed(0)} Triệu`;
  return formatNumber(amount);
}

export function formatSalaryRange(min: number | null | undefined, max: number | null | undefined): string {
  if (min && max) return `${formatSalary(min)} - ${formatSalary(max)}`;
  if (min) return `Từ ${formatSalary(min)}`;
  if (max) return `Đến ${formatSalary(max)}`;
  return 'Thỏa thuận';
}
